import { rtdb } from '../../config/firebase';
import { ref, set, update, remove, onChildChanged, orderByChild, equalTo, get, query } from 'firebase/database';
import { getAuth } from 'firebase/auth';
// let xlsx = require("json-as-xlsx");

//--------------------------------------------------------------------------------------//
//-----------------------------FUNCIONES DE BASE DE DATOS-------------------------------//
//--------------------------------------------------------------------------------------//

// leer datos
export const getCollections = async (collection) => {
	let data = {};
	const dataSnapshot = await get(query(ref(rtdb, `${collection}`)));
	if (dataSnapshot.exists()) {
		data = Object.values(dataSnapshot.val());
	}
	return data;
};

export const getCollectionsComplete = async (collection) => {
	let data = {};
	const dataSnapshot = await get(query(ref(rtdb, `${collection}`)));
	if (dataSnapshot.exists()) {
		data = dataSnapshot.val();
	}
	return data;
};

// ✅ NUEVA FUNCIÓN: Obtiene colecciones CON sus IDs incluidos
export const getCollectionsWithIds = async (collection) => {
	let data = [];
	const dataSnapshot = await get(query(ref(rtdb, `${collection}`)));

	if (dataSnapshot.exists()) {
		const val = dataSnapshot.val();
		// Convertir objeto a array manteniendo las keys como 'id'
		data = Object.keys(val).map((key) => ({
			id: key,
			...val[key],
		}));
	}

	return data;
};

// set datos
export const setData = async (collection, id, json) => {
	set(ref(rtdb, `${collection}/${id}`), json);
};

// buscar dato por id
export const searchData = async (collection, id) => {
	const dbRef = ref(rtdb, `${collection}/${id}`);
	try {
		const snapshot = await get(dbRef);
		if (snapshot.exists()) {
			return snapshot.val();
		}
		return null;
	} catch (error) {
		// console.error('Error al buscar datos:', error);
		return null;
	}
};

// buscar dato por valor
export const searchDataByValue = async (collection, key, value) => {
	let data = {};
	const dataSnapshot = await get(query(ref(rtdb, `${collection}`), orderByChild(`${key}`), equalTo(`${value}`)));
	if (dataSnapshot.exists()) {
		data = Object.values(dataSnapshot.val())[0];
	}
	return data;
};

// buscar datos que incluyen
/**
 *
 * Buscar los registros con un where
 * @param collection - string Colección de la base de datos
 * @para ids - array Array de los id a buscar
 *
 */
export const searchDataIncludes = async (collection, ids) => {
	if (!Array.isArray(ids)) return null;

	const promises = ids.map(async (id) => {
		const dbRef = ref(rtdb, `${collection}/${id}`);
		const snapshot = await get(dbRef);
		return snapshot.exists() ? snapshot.val() : null;
	});

	const results = await Promise.all(promises);
	return results.filter(Boolean);
};

// actualizar datos
export const updateData = async (collection, id, json) => {
	update(ref(rtdb, `${collection}/${id}`), json);
};

// actualizar todos los datos
export const updateAll = async (collection, json) => {
	update(ref(rtdb, `${collection}`), json);
};

// actualizar datos Data Users
export const updateDataUser = async (json) => {
	const userID = localStorage.getItem('6UIF_ZOFXc');
	update(ref(rtdb, `users/${userID}`), json).catch((e) => console.error(e));
};

// borrar datos
export const deleteData = async (collection, id) => {
	remove(ref(rtdb, `${collection}/${id}`));
};

// child changed
export async function childChange(collection) {
	let json = {};
	const collectionRef = ref(rtdb, `${collection}/`);
	onChildChanged(collectionRef, (data) => {
		json = data.val();
	});
	return json;
}

//--------------------------------------------------------------------------------------//
//-----------------------------FUNCIONES DE USUARIO-------------------------------------//
//--------------------------------------------------------------------------------------//

/**
 * ✅ NUEVA FUNCIÓN: Obtiene el UID del usuario desde sessionStorage
 * Maneja tanto el formato antiguo (JSON completo) como el nuevo (solo UID)
 */
export const getUserId = () => {
	try {
		const sessionData = sessionStorage.getItem(process.env.REACT_APP_VARIABLE_SESION_STORAGE);

		if (!sessionData) {
			return null;
		}

		// Intentar parsear como JSON (formato antiguo)
		try {
			const userData = JSON.parse(sessionData);
			// Si es un objeto, retornar el UID
			return userData.uid || userData.id || null;
		} catch (e) {
			// Si no es JSON válido, es el UID directo (formato nuevo)
			return sessionData;
		}
	} catch (error) {
		console.error('Error obteniendo UID del usuario:', error);
		return null;
	}
};

/**
 * ✅ NUEVA FUNCIÓN: Obtiene los datos completos del usuario desde Firebase
 * Si no están en cache, los obtiene de la BD
 */
export const getUserData = async () => {
	try {
		const uid = getUserId();
		if (!uid) {
			return null;
		}

		// Intentar obtener desde sessionStorage (formato antiguo)
		const sessionData = sessionStorage.getItem(process.env.REACT_APP_VARIABLE_SESION_STORAGE);
		try {
			const userData = JSON.parse(sessionData);
			if (userData && userData.nombre && userData.perfil) {
				return userData; // Ya tenemos los datos completos
			}
		} catch (e) {
			// No hay datos completos, obtenerlos de Firebase
		}

		// Obtener datos desde Firebase
		const userData = await getCollectionsComplete(`${process.env.REACT_APP_BD_USUARIOS}/${uid}`);
		return userData;
	} catch (error) {
		console.error('Error obteniendo datos del usuario:', error);
		return null;
	}
};

/**
 * ✅ ACTUALIZADA: Compatible con ambos formatos
 * @deprecated - Usar getUserData() en su lugar
 */
export async function userActive() {
	return await getUserData();
}

/**
 * ✅ NUEVA FUNCIÓN: Versión síncrona para obtener datos del usuario si están en cache
 * Si no están en cache, retorna null
 */
export function getUsuarioActivo() {
	try {
		const sessionData = sessionStorage.getItem(process.env.REACT_APP_VARIABLE_SESION_STORAGE);
		if (!sessionData) {
			return null;
		}

		// Intentar parsear como JSON (formato antiguo)
		try {
			const userData = JSON.parse(sessionData);
			// Verificar que el usuario tenga las propiedades necesarias
			if (userData && (userData.id || userData.uid) && userData.perfil) {
				return userData;
			}
		} catch (e) {
			// Si no es JSON, es el UID (formato nuevo)
			// Retornar null para que el componente obtenga los datos de Firebase
			return null;
		}

		return null;
	} catch (e) {
		console.error('Error obteniendo usuario activo', e);
		return null;
	}
}

export const buscarUsuarioPorCorreo = async (correo) => {
	const usuariosRef = ref(rtdb, 'usuarios');
	const q = query(usuariosRef, orderByChild('correo'), equalTo(correo));
	const snapshot = await get(q);

	if (snapshot.exists()) {
		let usuarioId;
		snapshot.forEach((childSnapshot) => {
			usuarioId = childSnapshot.key;
		});
		return usuarioId;
	}
};

//--------------------------------------------------------------------------------------//
//-----------------------------FUNCIONES GENERALES--------------------------------------//
//--------------------------------------------------------------------------------------//

function quitarAcentos(cadena) {
	const acentos = {
		á: 'a',
		é: 'e',
		í: 'i',
		ó: 'o',
		ú: 'u',
		Á: 'A',
		É: 'E',
		Í: 'I',
		Ó: 'O',
		Ú: 'U',
		Ñ: 'n',
		ñ: 'n',
	};
	return cadena
		.split('')
		.map((letra) => acentos[letra] || letra)
		.join('')
		.toString();
}

export function cambiarTextos(string) {
	const minusculas = string.toLowerCase();
	const sinEspacios = minusculas.replace(' ', '-');
	const sinTildes = quitarAcentos(sinEspacios);
	return sinTildes;
}

export function stringToArray(string, separador = ',') {
	const array = string.split(separador);
	return array;
}

export function capitalize(string) {
	const resultado = string.charAt(0).toUpperCase() + string.slice(1);
	return resultado;
}

export function cualMes(id) {
	let mes = '';
	switch (id) {
		case '01':
			mes = 'Enero';
			break;
		case '02':
			mes = 'Febrero';
			break;
		case '03':
			mes = 'Marzo';
			break;
		case '04':
			mes = 'Abril';
			break;
		case '05':
			mes = 'Mayo';
			break;
		case '06':
			mes = 'Junio';
			break;
		case '07':
			mes = 'Julio';
			break;
		case '08':
			mes = 'Agosto';
			break;
		case '09':
			mes = 'Septiembre';
			break;
		case '10':
			mes = 'Octubre';
			break;
		case '11':
			mes = 'Noviembre';
			break;
		case '12':
			mes = 'Diciembre';
			break;

		default:
			break;
	}
	return mes;
}

export function getDate(use24Hours = true) {
	const today = new Date();

	const year = today.getFullYear();
	const month = String(today.getMonth() + 1).padStart(2, '0');
	const day = String(today.getDate()).padStart(2, '0');

	let hours = today.getHours();
	const minutes = String(today.getMinutes()).padStart(2, '0');
	const seconds = String(today.getSeconds()).padStart(2, '0');

	// Formato 24 horas
	if (use24Hours) {
		return `${year}-${month}-${day} ${String(hours).padStart(2, '0')}:${minutes}:${seconds}`;
	}

	// Formato 12 horas
	const meridian = hours >= 12 ? 'pm' : 'am';

	hours = hours % 12 || 12;

	return `${year}-${month}-${day} ${String(hours).padStart(2, '0')}:${minutes}:${seconds} ${meridian}`;
}

export function validateEmail(email) {
	const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}

export function setFavicons(favImg) {
	const headTitle = document.querySelector('head');
	const setFavicon = document.createElement('link');
	setFavicon.setAttribute('rel', 'shortcut icon');
	setFavicon.setAttribute('href', favImg);
	headTitle.appendChild(setFavicon);
}

export async function downloadFile(file, name) {
	try {
		const response = await fetch(file);
		const blob = await response.blob();

		const url = window.URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.download = name;

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		window.URL.revokeObjectURL(url);
	} catch (error) {
		console.error('Error al descargar la imagen:', error);
		alert('Hubo un error al intentar descargar la imagen. Verifica la consola para más detalles.');
	}
}

export function top() {
	window.scrollTo(0, 0);
}

export function shuffle(array) {
	return array.sort((a, b) => 0.5 - Math.random());
}

// Deteccion de browser
export function browser() {
	let dispositivo = navigator.userAgent;
	let browser = 'Desconocido';

	switch (true) {
		case /Edge/.test(dispositivo):
			browser = 'Edge';
			break;
		case /Firefox/.test(dispositivo):
			browser = 'Firefox';
			break;
		case /OPR/.test(dispositivo):
			browser = 'Opera';
			break;
		case /Chrome/.test(dispositivo) && /Google Inc/.test(navigator.vendor):
			browser = 'Chrome';
			break;
		case dispositivo.includes('Chrome') && !dispositivo.includes('Android'):
			browser = 'ChromeWeb';
			break;
		case dispositivo.includes('Chrome') && dispositivo.includes('Android'):
			browser = 'ChromeMovil';
			break;
		case /Safari/.test(dispositivo) && /Apple Computer/.test(navigator.vendor):
			browser = 'SafariWeb';
			break;
		case /MSIE/.test(dispositivo) || /Trident/.test(dispositivo):
			browser = 'Explorer';
			break;
		case /Opera Mini/.test(dispositivo):
			browser = 'OperaMini';
			break;
		case /CriOS/.test(dispositivo):
			browser = 'ChromeiOS';
			break;
		case /FxiOS/.test(dispositivo):
			browser = 'FirefoxiOS';
			break;
		case /iPhone/.test(dispositivo) && /Safari/.test(dispositivo):
			browser = 'SafariiOS';
			break;
		case /android/i.test(dispositivo):
			browser = 'Android';
			break;
		case /iphone|ipad|ipod/i.test(dispositivo):
			browser = 'iOS';
			break;
	}
	return browser;
}

export function isMobile() {
	let isMobile = false;
	if (
		navigator.userAgent.match(/Android/i) ||
		navigator.userAgent.match(/webOS/i) ||
		navigator.userAgent.match(/iPhone/i) ||
		navigator.userAgent.match(/iPad/i) ||
		navigator.userAgent.match(/iPod/i) ||
		navigator.userAgent.match(/BlackBerry/i) ||
		navigator.userAgent.match(/Windows Phone/i)
	) {
		isMobile = true;
	}
	return isMobile;
}

export function validarFechas(fecha) {
	let pasa = false;
	const today = new Date();
	const year = today.getFullYear().toString();
	let month = (today.getMonth() + 1).toString();
	let day = today.getDate().toString();
	if (month.toString().length === 1) {
		month = '0' + month;
	}
	if (day.toString().length === 1) {
		day = '0' + day;
	}

	let fechaActual = `${year}-${month}-${day}`;
	if (fechaActual > fecha) {
		pasa = false;
	} else {
		pasa = true;
	}
	return pasa;
}

//--------------------------------------------------------------------------------------//
//-----------------------------FUNCIONES DE FIREBASE AUTH------------------------------//
//--------------------------------------------------------------------------------------//

/**
 * Elimina un usuario tanto de Firebase Auth como de la base de datos
 * @param {string} uid - UID del usuario a eliminar
 * @returns {Promise} - Resultado de la operación
 */
export const eliminarUsuarioFirebaseAuth = async (uid) => {
	try {
		const auth = getAuth();
		const currentUser = auth.currentUser;

		if (!currentUser) {
			throw new Error('Usuario no autenticado en Firebase Auth');
		}

		const accessToken = await currentUser.getIdToken();

		const response = await fetch(process.env.REACT_APP_CLOUD_FUNCTION_ELIMINAR_USUARIO, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${accessToken}`,
			},
			body: JSON.stringify({ uid }),
		});

		if (!response.ok) {
			const errorData = await response.json().catch(() => ({ error: 'Error desconocido' }));
			console.error('❌ Error en la respuesta:', errorData);
			throw new Error(errorData.error || errorData.message || `HTTP error! status: ${response.status}`);
		}

		const result = await response.json();
		return result;
	} catch (error) {
		console.error('❌ Error eliminando usuario de Firebase Auth:', error);

		if (error.message.includes('Failed to fetch') || error.message.includes('ERR_FAILED')) {
			throw new Error('Error de conexión. Verifica que las Firebase Functions estén desplegadas y activas.');
		}

		throw error;
	}
};
